import { normalizePages } from "./skillAgentMoodboardLayout";

export const PAGES_HISTORY_LIMIT = 50;

/** Snapshot profundo normalizado del layout (páginas + slots + marks). */
export function clonePagesSnapshot(pages) {
  return normalizePages(
    JSON.parse(JSON.stringify(Array.isArray(pages) ? pages : [])),
  );
}

export function createPagesHistory(limit = PAGES_HISTORY_LIMIT) {
  const n = Math.max(1, Math.min(200, Number(limit) || PAGES_HISTORY_LIMIT));
  return { past: [], future: [], limit: n };
}

/**
 * Guarda el estado actual ANTES de mutar.
 * Limpia redo.
 */
export function pushPagesHistory(hist, pages) {
  const h = hist || createPagesHistory();
  const snap = clonePagesSnapshot(pages);
  const past = [...(h.past || []), snap];
  const limit = h.limit || PAGES_HISTORY_LIMIT;
  return {
    past: past.length > limit ? past.slice(past.length - limit) : past,
    future: [],
    limit,
  };
}

export function undoPagesHistory(hist, currentPages) {
  const h = hist || createPagesHistory();
  if (!(h.past || []).length) {
    return { hist: h, pages: null };
  }
  const past = [...h.past];
  const prev = past.pop();
  const current = clonePagesSnapshot(currentPages);
  const future = [current, ...(h.future || [])];
  const limit = h.limit || PAGES_HISTORY_LIMIT;
  return {
    hist: {
      past,
      future: future.length > limit ? future.slice(0, limit) : future,
      limit,
    },
    pages: prev,
  };
}

export function redoPagesHistory(hist, currentPages) {
  const h = hist || createPagesHistory();
  if (!(h.future || []).length) {
    return { hist: h, pages: null };
  }
  const future = [...h.future];
  const next = future.shift();
  const current = clonePagesSnapshot(currentPages);
  const past = [...(h.past || []), current];
  const limit = h.limit || PAGES_HISTORY_LIMIT;
  return {
    hist: {
      past: past.length > limit ? past.slice(past.length - limit) : past,
      future,
      limit,
    },
    pages: next,
  };
}

export function clearPagesHistory(hist) {
  const h = hist || createPagesHistory();
  return { past: [], future: [], limit: h.limit || PAGES_HISTORY_LIMIT };
}

export function canUndoPages(hist) {
  return Boolean(hist?.past?.length);
}

export function canRedoPages(hist) {
  return Boolean(hist?.future?.length);
}
